module.exports = __webpack_public_path__ + "static/media/btbms-2025-alt2-en.d1072b01.jpg";